import script from "./roleManage.vue?vue&type=script&setup=true&lang=js"
export * from "./roleManage.vue?vue&type=script&setup=true&lang=js"

import "./roleManage.vue?vue&type=style&index=0&id=c3d0bcf4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3d0bcf4"]])

export default __exports__